const locale = {
  blank: 'Selecione uma Data',
  headerFormat: 'D/MM/YY',
  locale: require('date-fns/locale/pt'), // You need to pass in the date-fns locale for the language you want (unless it's EN)
  todayLabel: {
    long: 'Hoje',
    short: 'Hoje',
  },
  weekdays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  weekStartsOn: 0, // Start the week on Sunday
};

export default locale;


// WEBPACK FOOTER //
// ./src/commons/Locale.js